import {BaseEntity} from "../entities/BaseEntity";
import {PagingModel} from "../models/paging/PagingModel";
import { StateParams, StateService } from "@uirouter/angularjs";
import {NotificationService} from "../services/NotificationService";
import {pagination} from "ui-grid";
import angular from "angular";
import {ApplicationSetting} from "../entities/ApplicationSetting";

export class PagingCtrl<T extends BaseEntity> {
    pagingModel: PagingModel<T>;
    tempSearch: string;
    $scope: any;
    locationService: ng.ILocationService;
    stateParamsService: StateParams;
    stateService: StateService;
    gridOptions: any = null;

    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor($scope:any, $location: ng.ILocationService, stateService: StateService,
                stateParamsService: StateParams,
                pagingModel: PagingModel<T>,
                public notificationService: NotificationService) {
        //this.todos = $scope.todos = todoStorage.get();
        this.pagingModel = pagingModel;
        this.stateService = stateService;
        this.stateParamsService = stateParamsService;
        this.$scope = $scope;
        this.locationService = $location;
        $scope.vm = this;
        // Reset the pagination information
        this.pagingModel.search = stateParamsService["search"] ? stateParamsService["search"] : "";
        this.pagingModel.page = stateParamsService["page"] ? +stateParamsService["page"] : 1;
        this.pagingModel.pageSize = stateParamsService["pageSize"] ? +stateParamsService["pageSize"] : 10;
        this.pagingModel.orderColumn = (stateParamsService["orderColumn"] != null) ? stateParamsService["orderColumn"] : "";
        this.pagingModel.orderDirection = (stateParamsService["orderDirection"] != null) ? stateParamsService["orderDirection"] : "";
        this.tempSearch = this.pagingModel.search;
        this.updateLocation();
        // Define grid options
        this.gridOptions = {
            paginationPageSizes: [10, 15, 20, 50, 100, 500],
            paginationPageSize: this.pagingModel.pageSize,
            useExternalPagination: true,
            useExternalSorting: true,
            columnDefs: [],
            totalItems: 100000,

            minRowsToShow: this.pagingModel.pageSize + 4,
            data: [],
            onRegisterApi: function (gridApi:any) {
                gridApi.pagination.seek($scope.vm.pagingModel.page);
                gridApi.core.on.sortChanged($scope, function (grid:any, sortColumns:any) {
                    if (sortColumns.length == 0) {
                        $scope.vm.pagingModel.orderColumn = null;
                    } else {
                        $scope.vm.pagingModel.orderColumn = sortColumns[0].field;
                        $scope.vm.pagingModel.orderDirection = sortColumns[0].sort.direction;
                    }
                    $scope.vm.getPaged();
                });
                gridApi.pagination.on.paginationChanged($scope, function (newPage:any, pageSize:any) {
                    //alert(angular.element(document.getElementsByClassName('grid')[0]));
                    //$scope.vm.gridOptions.minRowsToShow = pageSize+1;
                    //$scope.vm.gridOptions.virtualizationThreshold = pageSize+1;
                    var maxRows = Math.min(pageSize, $scope.vm.gridOptions.totalItems);
                    angular.element(document.getElementsByClassName('grid')[0]).css('height', maxRows * 30 + 90 + 'px');
                    $scope.vm.pagingModel.page = newPage;
                    $scope.vm.pagingModel.pageSize = pageSize;
                    $scope.vm.gridOptions.minRowsToShow = pageSize + 2;
                    $scope.vm.updateLocation();
                    $scope.vm.getPaged();
                });
                gridApi.selection.on.rowSelectionChanged($scope, function (row:any) {
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if (row.isSelected)
                        $scope.vm.pagingModel.addSelected(entity);
                    else
                        $scope.vm.pagingModel.removeSelected(entity);
                });
                gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows:any) {
                    $.each(rows, (i, row) => {
                        var entity = row.entity;
                        if (row.isSelected)
                            $scope.vm.pagingModel.addSelected(entity);
                        else
                            $scope.vm.pagingModel.removeSelected(entity);
                    });
                });
            }
        };
        this.pagingModel.getColumnDefs().then(() => {
            this.gridOptions.columnDefs = this.setColumns();
            //this.gridOptions.data
        });
        this.init();
        this.getPaged();
    }

    init(): any {
    }

    setColumns(): any {
        var cols: any = [];
        var dateFilter = ApplicationSetting.applicationSetting.dateFormat;
        $.each(this.pagingModel.nameValuePairs, (index, nv) => {
            //console.log("field="+nv[0]+" and display="+nv[1]);
            if (nv[0] == "created" || nv[0] == "lastInventoried" || nv[0] == "vTagLastMoved" || nv[0] == "vTagLastSeen" || nv[0] == "lastModified" || nv[0] == "timeseen" || nv[0] == "lastObservedTime" || nv[0] == "eventTime" || nv[0] == "alarmTime" || nv[0] == "lastAttempt" || nv[0] == "ackTime" || nv[0] == "lastGPSFix" || nv[0] == 'lastSeen' || nv[0] == 'nextMaintenance' || nv[0] == 'lastMaintenance') {
                cols.push({
                    field: nv[0],
                    name: nv[1],
                    displayName: nv[1],
                    width: nv[2],
                    cellFilter: "date:'" + dateFilter + "'",
                    enableSorting: true,
                    sort: null
                });
            } else
                cols.push({
                    field: nv[0],
                    name: nv[1],
                    displayName: nv[1],
                    width: nv[2],
                    enableSorting: true,
                    sort: null
                });
        });
        return cols;
    }

    getPaged(): void {
        this.pagingModel.getPaged().then(() => {
            this.gridOptions.totalItems = this.pagingModel.totalItems;
            this.gridOptions.data = this.pagingModel.items;
        });
    }


    searchClick(): void {
        this.pagingModel.search = this.tempSearch;
        this.getPaged();
        this.updateLocation();
    }

    updateLocation(): void {
        this.locationService.search({
            search: this.pagingModel.search,
            page: this.pagingModel.page,
            pageSize: this.pagingModel.pageSize,
            orderColumn: this.pagingModel.orderColumn,
            orderDirection: this.pagingModel.orderDirection
        });
    }
}
